import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { IDetailedInfoFilter } from '../../model/types/DetailedInfoFilter.interface'
import { selectDetailedInfoFilters } from '../../model/domainOverviewSlice'
import React, { useEffect, useState } from 'react'
import {
  AdvertisingResearchItems,
  AdvertisingResearchKeywordItems,
  GetResearchAdvertisingKeywordApiArg,
  ResearchAdvertisingKeywordArg,
  useGetResearchAdvertisingKeywordQuery,
} from '../../../../app/api'
import { Square } from '../../../../shared/components/utility/square/Square'
import { ColumnsType } from 'antd/lib/table'
import { Table } from 'antd'
import { useTranslation } from 'react-i18next'
import { PositionCell } from '../../ui/cells/PositionCell'
import { DetailsCell } from '../../ui/cells/DetailsCell'
import clsx from 'clsx'
import styles from './PagesTableExpandedRow.module.scss'

interface DetailedInfoPagesExpandedRowProps {
  record: AdvertisingResearchItems
}

export const PagesTableExpandedRow = ({ record }: DetailedInfoPagesExpandedRowProps) => {
  const { t } = useTranslation()
  const detailedInfoFilter = useAppSelector<IDetailedInfoFilter>(selectDetailedInfoFilters)
  const {
    project,
    site,
    country,
    engine_id,
    dateRange: date,
    keyword,
    has_brand,
    page_url,
    show_hidden,
    reversed_filters,
  } = detailedInfoFilter

  const [queryParams, setQueryParams] = useState<Partial<ResearchAdvertisingKeywordArg>>()
  const { data, isLoading, isFetching } = useGetResearchAdvertisingKeywordQuery(
    queryParams as GetResearchAdvertisingKeywordApiArg,
    { skip: !project || queryParams == undefined },
  )

  useEffect(() => {
    if (!project) return

    setQueryParams({
      page: 1,
      'per-page': record.keywords_count,
      projectId: +project,
      site,
      countryId: country ? +country : undefined,
      engineId: +engine_id,
      date,
      keywordId: keyword || undefined,
      hasBrand: has_brand,
      landingId: page_url || undefined,
      showHidden: show_hidden,
      title: record.title,
      url: record.url,
      reversedFilters: (reversed_filters || undefined) as unknown as string[],
    })
  }, [detailedInfoFilter])

  const columns: ColumnsType<AdvertisingResearchKeywordItems> = [
    {
      title: t('table.columns.keyword'),
      dataIndex: 'keyword',
      key: 'keyword',
    },
    {
      title: t('table.columns.avgPosition'),
      dataIndex: 'position',
      key: 'position',
      render: (_: string, record) => <PositionCell {...record} />,
      sorter: true,
    },
    {
      title: t('table.columns.lastUpdated'),
      dataIndex: 'last_found',
      key: 'last_found',
      width: 150,
      sorter: true,
    },
    {
      title: t('table.columns.details'),
      key: 'details',
      render: (_: string, record) => <DetailsCell {...record} />,
    },
  ]

  return (
    <Square className={clsx(styles.root)}>
      <Table
        className='transparent-header'
        columns={columns}
        dataSource={data?.data?.items}
        loading={isLoading || isFetching}
        pagination={false}
        rowClassName={(e) => (e.position === 0 ? 'disabled' : '')}
      />
    </Square>
  )
}
